export default __webpack_public_path__ + "static/graphic-data-privacy-b336d35461791b73483e395518af6bca.svg";